import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-shell" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = { class: "language-switch" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MeshBackdrop = _resolveComponent("MeshBackdrop")!
  const _component_CursorSpotlight = _resolveComponent("CursorSpotlight")!
  const _component_ThemeToggle = _resolveComponent("ThemeToggle")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MeshBackdrop),
    _createVNode(_component_CursorSpotlight),
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_ThemeToggle),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["lang-btn glass-button", { active: _ctx.currentLocale === 'en' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLocale('en')))
        }, " EN ", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["lang-btn glass-button", { active: _ctx.currentLocale === 'de' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLocale('de')))
        }, " DE ", 2)
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}